import React from 'react';
import classes from './TupleDivider.scss';

const tupleDivider = () => (
    <div className={classes.Divider}></div>
);

export default tupleDivider;


// WEBPACK FOOTER //
// ./src/components/Flight/UI/Mobile/Tuple/TupleDivider/TupleDivider.js